// extracted by mini-css-extract-plugin
export default {"sameAsSiteWrapper":"EditPrintDesign_sameAsSiteWrapper__KWhOo","roundedCornersWrapper":"EditPrintDesign_roundedCornersWrapper__l0m-P"};